import {State, Module} from 'app/decorators';
import BaseRoute from 'app/routing';
import UserStore from 'app/stores/user';

import {UserListCtrl, UserCtrl} from './ctrls';
import CompaniesComponent from 'app/directives/companies.component';
import RolePicker from 'app/directives/role.picker';
import EmailToComponent from 'app/admin/components/emailto.component';

import mainTpl from './templates/main.html';
import detailTpl from './templates/details.html';

import tableSectionTpl from './templates/table.section.html';
import detailSectionTpl from './templates/detail.section.html';


@Module({
    name: 'app.admin.users',
    modules: [
        BaseRoute,
        UserStore,
        CompaniesComponent,
        RolePicker,
        EmailToComponent,
    ],
})
@State({
    name: 'r.in.top.admin.users',
    url: '/users',
    template: mainTpl,
    ncyBreadcrumb: {
        skip: true,
    },
    abstract: '.list',
    data: {
        permissions: {
            only: [
                'main.view_user',
            ]
        }
    }
})
@State({
    name: 'r.in.top.admin.users.list',
    url: '?search',
    views: {
        tableView: {
            template: tableSectionTpl,
            controller: UserListCtrl,
        },
        detailsView: {
            template: detailSectionTpl,
            controller: UserCtrl,
        },
    },
    resolve: {
        $object: function () {
            return null;
        },
    },
    ncyBreadcrumb: {
        label: 'Users',
    },
})
@State({
    name: 'r.in.top.admin.users.list.user',
    url: '/{objectId:int}',
    ncyBreadcrumb: {
        skip: true,
    },
    template: '<ui-view/>',
    resolve: {
        $object: function($stateParams, UserStore) {
            return UserStore.get($stateParams.objectId, {extra_field: 'account'});
        },
    },
    abstract: '.detail',
})
@State({
    name: 'r.in.top.admin.users.list.user.detail',
    url: '/details',
    controller: UserCtrl,
    template: detailTpl,
    ncyBreadcrumb: {
        label: '{{ vm.object.username }}',
    },
})
export default class States { }



// WEBPACK FOOTER //
// ./src/app/admin/users/routing.js